import { ITrangThaiHocActionTypes } from "../../action-types/category/ITrangThaiHocActions";
import { ITrangThaiHocReducer } from "../../reducer-model/category/ITrangThaiHocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: ITrangThaiHocReducer = {
    status: eReducerStatusBase.is_not_initialization,
    trangThaiHocs: [],
}

const trangThaiHocReducer = (state: ITrangThaiHocReducer = iniState, action: ITrangThaiHocActionTypes): ITrangThaiHocReducer => {
    switch (action.type) {
        case "TRANG_THAI_HOC_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "TRANG_THAI_HOC_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                trangThaiHocs: action.payload,
            };
        case "TRANG_THAI_HOC_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}
export default trangThaiHocReducer;